import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function DetailsError({
  renderedErrorLink,
  unifiedDetailsError
}) {
  var _unifiedDetailsError$;
  // @ts-ignore ts-migrate(2339) FIXME: Property 'cause' does not exist on type '{}'
  const errorType = (_unifiedDetailsError$ = unifiedDetailsError.cause) === null || _unifiedDetailsError$ === void 0 || (_unifiedDetailsError$ = _unifiedDetailsError$.cause) === null || _unifiedDetailsError$ === void 0 || (_unifiedDetailsError$ = _unifiedDetailsError$.cause) === null || _unifiedDetailsError$ === void 0 ? void 0 : _unifiedDetailsError$.type;
  switch (errorType) {
    case 'UNAUTHORIZED_BETA_SLUG_ACCESS':
      return /*#__PURE__*/_jsx(ErrorMessage, {
        illustration: "keys",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `detailsPage.error.${errorType}`
        }),
        children: renderedErrorLink
      });
    case 'LISTING_NOT_FOUND':
      return /*#__PURE__*/_jsx(ErrorMessage, {
        type: "notFound",
        children: renderedErrorLink
      });
    default:
      return /*#__PURE__*/_jsx(ErrorMessage, {
        type: "badRequest",
        children: renderedErrorLink
      });
  }
}